import styled from 'styled-components/macro';

const SpellingDialogStyled = styled.div`
  min-width: 160px;
  max-height: 400px;
  padding: 5px 0;
  overflow: auto;
  overflow-x: hidden;
  background-color: #3d3234;
  color: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 16px 0 rgba(40, 35, 36, 0.6);
`;

export default SpellingDialogStyled;
